import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { SubmitButton } from 'components/FormFields/SubmitButton';
import { RouteContext } from 'lib/ContextTypes';

const TITLES = {
  article: 'Sign up for your free TODAY account to read this article!',
  recipe: 'Sign up for your free TODAY account to get this recipe!',
  default: 'Access with your free TODAY account!',
};

/**
 * Displays a version of the account gate prompt in the chromeless / app view
 *
 * @param {object} props
 * @param {string} [props.contentType='default'] - The type of content being accessed.
 * @returns {JSX.Element}
 */
const ChromelessScreen = ({
  contentType = 'default',
}) => {
  const { path } = useContext(RouteContext);
  /**
   * Handles the signup button click by opening the signup page in a browser to follow the login process.
   */
  const handleSignup = () => {
    if (typeof window !== 'undefined') {
      const [url] = path.split('?');
      window.open(`${url}?account=signup`, '_blank');
    }
  };

  return (
    <>
      <h2 data-testid="chromeless">{TITLES[contentType]}</h2>
      <SubmitButton
        onClick={handleSignup}
        title="Sign Up"
      />
    </>
  );
};

ChromelessScreen.propTypes = {
  contentType: PropTypes.string,
};

export { ChromelessScreen };
